import { createGlobalStyle } from "styled-components";

export const GlobalPaypalButtonStyle = createGlobalStyle`
	.paypal-buttons-disabled {
		opacity: 1 !important; 
	}
`;
